import React, { useState } from "react";
import { useTranslation } from "react-i18next";

function GroupCheckbox({ index, value, label = "", onChange }) {
    const { t } = useTranslation();
    const [ checked, setChecked ] = useState(value);

    const handleClick = (e) => {

        setChecked(!checked);

        onChange?.({
            type: 'onChange',
            data: !checked,
            index: index,
        });
    }

    return (
    <div className="checkboxEntityField">
        <input id={"checkbox_"+index+Date.now()}
            type="checkbox"
            checked={checked}
            onChange={(e) => handleClick(e)} />
        <label htmlFor={"checkbox_"+index+Date.now()}>{label}</label>
    </div>
    )
}

export default GroupCheckbox;
